/*
 * @Date: 2022-09-02 13:35:57
 * @LastEditors: Cclay
 * @LastEditTime: 2023-10-18 16:26:32
 * @FilePath: \zl_api_private_web\src\store.js
 * @Description: 我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    currentUrl: '/server-setting/server-ftp-maintenance',
    isPrivate: -1,
    companyInfo: {},
    funcModuleArray: [], // 人员权限
    isQiyeLogin: 0 // 通过密码登录还是扫码登录
  },
  mutations: {
    setCurrentUrl(state, currentUrl) {
      state.currentUrl = currentUrl;
    },
    setIsPrivate(state, isPrivate) {
      state.isPrivate = isPrivate;
    },
    setCompanyInfo(state, companyInfo) {
      state.companyInfo = companyInfo;
    },
    setFuncModuleArray(state, funcModuleArray) {
      state.funcModuleArray = funcModuleArray;
    }
  },
  actions: {}
})
